/**
 * @generated SignedSource<<f9aad55b76946288be8e719e254108c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "rejectNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RejectNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3f6c34e4dca452c085bea301baacab1",
    "id": null,
    "metadata": {},
    "name": "RejectNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation RejectNominatedTradeMutation(\n  $id: ID!\n) {\n  rejectNominatedTrade(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "89847f3c4ce38941f0933969438371bc";

module.exports = node;
